import { Context } from '#store/overmind';
import { filter } from 'overmind';
import { QueryParams } from '#store/namespaces/search/actions';
import { convertStateToSearchParams } from './state';
import { SearchParams } from '#types/generated/graphql-types';

const MIN_QUERY_LENGTH = 1;

export const setQuery = ({ state }: Context, params: QueryParams) => {
  state.search.query = params.query;
  state.search.loading = true;
  return params;
};

export const lengthGreaterThan = (length: number) =>
  // eslint-disable-next-line @typescript-eslint/no-shadow
  filter(function lengthGreaterThan(_, params: QueryParams) {
    return params.query.length > length;
  });

export const getSearchResult = async (
  { state, effects }: Context,
  params: QueryParams
) => {
  state.search.loading = true;
  const items = await effects.search.api.search(params.query);
  state.search.result = state.search.query ? items || [] : [];
  state.search.loading = false;
  return params;
};

export const getSearchCount = async ({ state, effects }: Context) => {
  state.search.countResult.loading = true;

  const { query, filters } = state.search;

  const apiParams: SearchParams = convertStateToSearchParams(filters);
  const count: number = await effects.search.api.getSearchCount(
    query,
    apiParams
  );

  state.search.countResult.count = count ?? 0;
  state.search.countResult.loading = false;
};

export const resetSearchCount = ({ state }: Context) => {
  state.search.countResult.loading = false;
  state.search.countResult.count = null;
};

export const shouldFetchCount = (context: Context) => {
  const { query } = context.state.search;
  const { filters } = context.state.search;

  const hasQuery = query.length >= MIN_QUERY_LENGTH;

  const hasFilters = Object.values(filters).some((val) => {
    if (val instanceof Set) {
      return val.size > 0;
    }
    return false;
  });

  return hasQuery || hasFilters;
};
